import { GenerateSnippetProps, GetPreviewFullSrcProps } from './types';

export const getPreviewFullSrc = ({
  link,
  multiplier = 1,
  sizes: { width, height },
  playButton: { enabled, color }
}: GetPreviewFullSrcProps) => {
  const previewWidth = width * multiplier;
  const previewHeight = height * multiplier;
  const previewSize = `?width=${previewWidth}&height=${previewHeight}`;
  const previewButton = !enabled ? '' : `&play=${enabled}&color=${color}`;

  return `${link}${previewSize}${previewButton}`;
};

export const generateSnippet = ({
  alt = 'by Wave.video',
  src,
  link,
  sizes,
  urlParams,
  playButton
}: GenerateSnippetProps) => {
  const previewSrc = getPreviewFullSrc({
    sizes,
    playButton,
    link: src,
    multiplier: 2
  });

  const params = urlParams ? `?${urlParams}` : '';

  const previewWrapperCenteredStyles = `style="display: block;margin: 0 auto;max-width: ${sizes.width}px"`;

  const previewStyles = `style="width: ${sizes.width}px"`;

  return `<a href="${link}${params}" ${previewWrapperCenteredStyles}><img src="${previewSrc}" alt="${alt}" ${previewStyles} /></a>`;
};
